import { createReducer } from "@reduxjs/toolkit";

import { EvalRunListFilter } from "@shared/interfaces";

import * as actions from "./actions";
import { EvaluationStateType } from "../interface";

const defaultEvalRunsFilter: EvalRunListFilter = {
  page: 0,
  limit: 20,
  search: "",
};

export const initialState: EvaluationStateType = {
  runs: [],
  run: null,
  runsTotal: null,
  filter: { ...defaultEvalRunsFilter },
  categories: null,
  isRunning: false,
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.getEvalRuns.success, (state, action) => {
    const { rows, clear, count } = action.payload;
    state.runs = clear ? [...rows] : [...state.runs, ...rows];
    state.runsTotal = count;
  });
  builder.addCase(actions.setEvalRunsFilter, (state, action) => {
    state.filter = action.payload || { ...defaultEvalRunsFilter };
  });
  builder.addCase(actions.getEvalRun.success, (state, action) => {
    state.run = action.payload;
  });
  builder.addCase(actions.clearEvalRun, (state) => {
    state.run = null;
  });
  builder.addCase(actions.deleteEvalRun.success, (state, action) => {
    state.runs = state.runs.filter((run) => run.uuid !== action.payload);
    state.runsTotal = Math.max((state.runsTotal || 0) - 1, 0);
  });
  builder.addCase(actions.getEvalCategories.success, (state, action) => {
    state.categories = action.payload;
  });
  builder.addCase(actions.runEvalFromCsv.request, (state) => {
    state.isRunning = true;
  });
  builder.addCase(actions.runEvalFromCsv.success, (state) => {
    state.isRunning = false;
  });
  builder.addCase(actions.runEvalFromCsv.failure, (state) => {
    state.isRunning = false;
  });
});

export { reducer as EvaluationReducer };
